define('drops/matrix/matrixTablesSynchronizer',[
    'jquery'
], function ($) {
    
    var RowSynchronizer = function($first, $second) {
        this.$rowsOfFirst = $first
            .find('tr');
        this.$rowsOfSecond = $second
            .find('tr');

        this.heightOfFirst = [];
        this.heightOfSecond = [];

        var self = this;
        this.$rowsOfFirst.each(function (i) {
            self.heightOfFirst[i] = this.getBoundingClientRect().height;
        });
        this.$rowsOfSecond.each(function (i) {
            self.heightOfSecond[i] = this.getBoundingClientRect().height;
        });
    };

    RowSynchronizer.prototype.sync = function () {
        var self = this;
        this.$rowsOfFirst.each(function (i, element) {
            var $firstRow = $(element);
            var $secondRow = $(self.$rowsOfSecond.get(i));

            var firstOuterHeight = self.heightOfFirst[i];
            var secondOuterHeight = self.heightOfSecond[i];

            // we have to set the width on both rows because of rounding issues (in IE and Firefox)
            if (firstOuterHeight > secondOuterHeight) {
                $firstRow.height(firstOuterHeight);
                $secondRow.height(firstOuterHeight);
            } else if (secondOuterHeight > firstOuterHeight) {
                $firstRow.height(secondOuterHeight);
                $secondRow.height(secondOuterHeight);
            }
        });
    };

    var ColumnSynchronizer = function ($first, $second) {
        this.$columnOfFirst = $first
            .find('tr:first')
            .find('td, th');
        this.$columnOfSecond = $second
            .find('tr:first')
            .find('td');

        this.widthOfFirst = [];
        this.widthOfSecond = [];

        var self = this;
        this.$columnOfFirst.each(function (i) {
            self.widthOfFirst[i] = {
                outerWidth: this.getBoundingClientRect().width,
                width: $(this).width() + 1 // adding 1 will fix a rounding issue -> in some browsers a width like '3.43' will be rounded to '3'
            };
        });
        this.$columnOfSecond.each(function (i) {
            self.widthOfSecond[i] = {
                outerWidth: this.getBoundingClientRect().width,
                width: $(this).width() + 1
            };
        });
    };

    ColumnSynchronizer.prototype.sync = function () {
        var self = this;
        this.$columnOfFirst.each(function (i, element) {
            var $firstColumn = $(element);
            var $secondColumn = $(self.$columnOfSecond.get(i));

            var firstWidth = self.widthOfFirst[i].width;
            var secondWidth = self.widthOfSecond[i].width;

            var firstOuterWidth = self.widthOfFirst[i].outerWidth;
            var secondOuterWidth = self.widthOfSecond[i].outerWidth;

            // we have to set the width on both columns because of rounding issues (in IE and Firefox)
            if (firstOuterWidth > secondOuterWidth) {
                var width = Math.ceil(firstOuterWidth - (secondOuterWidth - secondWidth));
                $secondColumn.css({
                    'min-width': width + 'px',
                    'max-width': width + 'px'
                });
                $firstColumn.css({
                    'min-width': width + 'px',
                    'max-width': width + 'px'
                });
            } else if (secondOuterWidth > firstOuterWidth) {
                var width = Math.ceil(secondOuterWidth - (firstOuterWidth - firstWidth));
                $firstColumn.css({
                    'min-width': width + 'px',
                    'max-width': width + 'px'
                });
                $secondColumn.css({
                    'min-width': width + 'px',
                    'max-width': width + 'px'
                });
            }
        });
    };

    return {
        syncFor: function (matrix) {
            var synchronizers = [
                new RowSynchronizer(matrix.$fixedHeaders, matrix.$dynamicHeaders),
                new RowSynchronizer(matrix.$fixedRows, matrix.$dynamicRows),
                new ColumnSynchronizer(matrix.$fixedHeaders, matrix.$fixedRows),
                new ColumnSynchronizer(matrix.$dynamicHeaders, matrix.$dynamicRows)
            ];

            _.each(synchronizers, function(synchronizer) {
                synchronizer.sync();
            });
        }
    };
});
